import axios from 'axios';
import { LDFlagSet } from 'launchdarkly-node-server-sdk';
import * as uuid from 'uuid';
import { DiagnosticFields } from '../../dto/diagnostics';
import { EventFlow } from '../../dto/events';
import {
  Correlator,
  DiagnosticsLogger,
  EventSender,
  withDataPointInternal,
} from '../base';

let correlationId: string;
let ldFlags: LDFlagSet = {};
export const setClientLoggingFlags = (flags: LDFlagSet) => {
  ldFlags = flags;
};

export const correlator: Correlator = {
  getCurrentOrGenerateNewId: () => {
    if (!correlationId) {
      correlationId = uuid.v4();
    }

    if (process.env.NEXT_PUBLIC_DD_ENV !== 'prod') {
      console.info(`Correlation id: ${correlationId}`);
    }

    return {
      correlationId,
      onCompleteFlow: () => {
        correlationId = undefined;
      },
    };
  },
  getCurrentId: () => correlationId,
};

const logger: DiagnosticsLogger = {
  error: dp => console.error(dp),
  debug: dp => console.log(dp),
};

const eventSender: EventSender = {
  sendEvent: async dp => {
    const { status } = await axios.post('/api/events', dp);
    return status === 201;
  },
};

export const withDataPoint = async <T = void>(
  flow: EventFlow,
  func: (dp: DiagnosticFields) => Promise<T>
): Promise<T> =>
  withDataPointInternal(
    'client',
    flow,
    func,
    correlator,
    logger,
    eventSender,
    ldFlags
  );
